const Schedule = () => {
    return (
        <div className="headerSchedule"><h2>Kalender Kegiatan</h2>
        <div className="schedule">
            <div className="schedule__left">
                <img src="/kalender.png" alt="kalender" />
            </div>
            <div className="schedule__right">
                <div className="schedule__1">
                    <h3>22 Jun <br /> 2022</h3>
                    <h3>Pembersihan Sungai Code bersama Pemkot Yogyakarta</h3>
                </div>
                <div className="schedule__2">
                    <h3>4 Jul <br /> 2022</h3>
                    <h3>Pameran Industri StartUp di Univeristas Gadjah Mada</h3>
                </div>
            </div>
        </div>
        </div>
    )
}

export default Schedule